module.exports = __webpack_public_path__ + "img/03_bg.b3d439fa.png";